import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ConfigField } from "../config-pane-parts";

/** No props: a real `Form.Item` now, so the form is the only state it has. */
class ConfigExpireOldSessions extends PureComponent {
  render(): ReactNode {
    return (
      <ConfigField
        label="Expire Old Sessions Upon New Login"
        tooltipContentKey="appsettings_expireoldsessionsuponnewlogin_expireoldsessionsuponnewlogin"
      >
        <Form.Item name={["apiConfig", "isExpireOldSessionsEnabled"]} valuePropName="checked" noStyle>
          <KuikaSwitch dataTestId="appSettingsExpireOldSessionsSwitch" />
        </Form.Item>
      </ConfigField>
    );
  }
}

export { ConfigExpireOldSessions };
